/**
 * Simple auth token management using localStorage.
 */

const TOKEN_KEY = 'ranxinview_token';
const EXPIRES_KEY = 'ranxinview_token_expires';

/** 登录态变化时向 window 派发的事件，供 Navbar 等组件响应式更新 */
const AUTH_EVENT = 'ranxinview:auth-change';

function notifyAuthChange(): void {
  window.dispatchEvent(new Event(AUTH_EVENT));
}

export function getToken(): string | null {
  const token = localStorage.getItem(TOKEN_KEY);
  const expires = localStorage.getItem(EXPIRES_KEY);
  if (!token || !expires) return null;

  // Check if token has expired
  if (Date.now() / 1000 > Number(expires)) {
    clearToken();
    return null;
  }

  return token;
}

export function setToken(token: string, expiresAt: number): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXPIRES_KEY, String(expiresAt));
  notifyAuthChange();
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRES_KEY);
  notifyAuthChange();
}

export function isLoggedIn(): boolean {
  return getToken() !== null;
}
